export const createEmojiTransformer = () => (props: { id: string }) => {
	return [
		{
			type: 'text',
			text: `${props.id} `,
		},
	];
};
